import { ErrorComponent, ThemedLayoutV2 } from '@refinedev/mui';
import { NavigateToResource } from '@refinedev/react-router';
import { Route, Routes } from 'react-router';
import { Header } from '../../components/index.ts';
import * as Organization from './organization/index.ts';

export default () => {
  return (
    <ThemedLayoutV2 Header={Header}>
      <Routes>
        <Route index element={<NavigateToResource resource="accounts/organizations" />} />
        <Route path="/organizations">
          <Route index element={<Organization.OrganizationList />} />
          <Route path="create" element={<Organization.OrganizationForm action="create" />} />
          <Route path="edit/:id" element={<Organization.OrganizationForm action="edit" />} />
          <Route path="show/:id" element={<Organization.OrganizationShow />} />
        </Route>
        <Route path="*" element={<ErrorComponent />} />
      </Routes>
    </ThemedLayoutV2>
  );
};
